module.exports = __webpack_public_path__ + "static/ARIALBDSEMIBOLD-f4ea0f809c8cdd9f71f00d85730d1a1c.otf";